import React from "react";
import linksAjudaApiClient from "../../api/linksAjuda";
import useApi from "../../hooks/useApi";
import PropTypes from "prop-types";
import { FaRegQuestionCircle } from "react-icons/fa";

function MeAjudaComponent({ identificador, children }) {
  const [link, setLink] = React.useState("");
  const { request: getLink, data: linkResponse } = useApi(
    linksAjudaApiClient.getLink,
    false
  );

  React.useLayoutEffect(() => {
    let newIdentificador = identificador;

    if (newIdentificador.startsWith("/")) {
      newIdentificador = newIdentificador
        .replace(process.env.REACT_APP_PREFIX, "")
        .replace(/\//g, "_")
        .replace("_", "");
    }

    getLink(newIdentificador);
  }, [getLink, identificador]);

  React.useLayoutEffect(() => {
    if (linkResponse) {
      setLink(linkResponse?.link || "");
    }
  }, [link, linkResponse]);

  return (
    <>
      {children}
      {link && (
        <FaRegQuestionCircle
          onClick={() => {
            window.open(link, "_blank");
          }}
          style={{
            color: "#556ee6",
            paddingLeft: "4px",
            cursor: "pointer",
            width: "1.15rem",
            height: "1.15rem",
          }}
        />
      )}
    </>
  );
}

MeAjudaComponent.propTypes = {
  identificador: PropTypes.string,
  children: PropTypes.any,
};

export default MeAjudaComponent;
